import { render, staticRenderFns } from "./ClassBioEdit.vue?vue&type=template&id=4503f8df&"
import script from "./ClassBioEdit.vue?vue&type=script&lang=js&"
export * from "./ClassBioEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports